import {forwardRef} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import TextField from '@mui/material/TextField'



const FormikTextField = forwardRef(({
  field: { name, value, onChange, onBlur },
  form:  { touched, errors, isSubmitting },
  // grab these so they don’t end up in `...other`
  disabled,
  startAdornment,
  innerRef,
  InputProps: incomingInputProps = {},
  // styling props
  sx,
  className,
  css,       
  helperText,
  // everything else (label, fullWidth, placeholder…)
  ...other
}, ref) => {

  const errorMsg = errors[name]
  const showError = Boolean(touched[name] && errorMsg)

  return (
    <TextField
      // Formik wiring
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      variant='filled'
      
      // forwarded ref
      inputRef={ref}

      // error state
      error={showError}
      helperText={showError ? errorMsg : helperText}
      disabled={disabled ?? isSubmitting}

      // styling
      sx={{fontSize: 16, ...sx}}
      className={className}
      css={css}

      // put your adornment inside MUI’s InputProps
      InputProps={{
        startAdornment,
        ...incomingInputProps
      }}

      // any other props (label, variant, fullWidth, etc)
      {...other}
    />
  )
})

export default FormikTextField